import { DateTime } from 'luxon';

// FIX: message timestamps depend only on the device's own local clock (Date.now()) —
// no network call, no third-party API, no own-domain API response/header of any kind.
//
// This replaces an earlier design that corrected the local clock using a server time
// source (first a third-party API, then our own domain's HTTP `Date` header). That
// correction mechanism was itself the cause of a production bug: the external time
// source occasionally returned a stale value (several minutes behind real time), and
// since every message timestamp was stamped via that "corrected" time, the bug leaked
// into every message sent while the bad value was cached. In every case we debugged,
// the device's own local clock was already correct — the network round trip was pure
// added risk with no benefit. Trusting Date.now() directly removes that risk entirely.
class TimeSync {

   getSyncedTime() {
      return Date.now();
   }

   getSyncedNow = () => DateTime.fromMillis(this.getSyncedTime());
}

const timeSync = new TimeSync();
export default timeSync;
